import styled from 'styled-components'

export const BoxRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
`
